import { getTemplate } from "../template-helper";

const COMPONENT_NAME = "z-form" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class FormComponent extends HTMLElement {
            constructor() {
                super();

                if(this.children.length>0 && 
                    (this.children[0].tagName === "FORM" || this.children[0].tagName === "TEMPLATE")){
                    //already have markup
                    this.applyReadonly() ;
                    return;
                }

                const innerHTML = this.innerHTML ;
                this.innerHTML = "" ;
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                this.form = this.querySelector("form") ;
                if(this.classList.contains("h-100")){
                    this.form.classList.add("h-100") ;
                }
                this.form.innerHTML = innerHTML ;

                if(this.hasAttribute("z-model")){
                    const model = this.getAttribute("z-model") ;
                    if(!this.hasAttribute("z-rest-url")){
                        
                        this.setAttribute("z-rest-url", "/api/rest/"+model) ;
                    }
                    let fieldId = "_id" ;
                    const modelDef = window.APP.schema.models.find(m => m.name === model) ;
                    if(modelDef){
                        const fieldPk = modelDef.columns.find(c => c.unique) ;
                        if(fieldPk){
                            fieldId = fieldPk.name ;
                        }
                    }

                    for(let btType of ["z-button-save", "z-button-delete", "z-button-form"]){
                        const elsBt = this.querySelectorAll(btType) ;
                        for(let i=0; i<elsBt.length; i++){
                            const bt = elsBt[i] ;
                            if(!bt.hasAttribute("z-field-id")){
                                bt.setAttribute("z-field-id", fieldId) ;
                            }
                        }
                    }
                }

                if(this.hasAttribute("z-rest-url")){
                    const restUrl = this.getAttribute("z-rest-url") ;
                    if(this.hasAttribute("z-inner-form")){
                        let mode = "create" ;
                        if(this.hasAttribute("z-form-mode")){
                            mode = this.getAttribute("z-form-mode") ;
                        }
                        if(mode === "create"){
                            //form inside a non form page
                            this.setAttribute("z-bind-url", "$emptyRecord") ;
                            this.setAttribute("z-save-url", restUrl) ;
                        }else{
                            this.setAttribute("z-bind-url", restUrl+"/${_globals.params.id}") ;
                            this.setAttribute("z-save-url", restUrl+"/${_globals.params.id}") ;
                        }
                    }else{
                        //global form of the page
                        this.setAttribute("z-bind-url", "${(!_globals.params.mode || _globals.params.mode==='create')?'$emptyRecord':'"+restUrl+"/'+_globals.params.id}") ;
                        this.setAttribute("z-save-url", "${(!_globals.params.mode || _globals.params.mode==='create')?'"+restUrl+"':'"+restUrl+"/'+_globals.params.id}") ;
                    }
                }

                if(this.getAttribute("z-bind-url")){
                    this.form.setAttribute("z-bind-url", this.getAttribute("z-bind-url")) ;
                    this.removeAttribute("z-bind-url") ;
                }
                if(this.getAttribute("z-save-url")){
                    this.form.setAttribute("z-save-url", this.getAttribute("z-save-url")) ;
                    this.removeAttribute("z-save-url") ;
                }
                if(!this.hasAttribute("readonly") && !this.hasAttribute("z-inner-form")){
                    this.setAttribute('readonly', "${_globals.params.mode === 'read'}");
                }
                
                if(!this.hasAttribute("z-bind") && this.hasAttribute("z-model")){
                    this.setAttribute("z-bind", this.getAttribute("z-model").replace(/^_+/, ""));
                }

                if(this.hasAttribute("z-bind")){
                    this.form.setAttribute("z-bind", this.getAttribute("z-bind")) ;
                    this.removeAttribute("z-bind") ;
                }

                this.applyReadonly() ;
            }

            get readonly() {
                return this.hasAttribute("readonly") ;
            }
            
            set readonly(readonly) {
                if(readonly){
                    this.setAttribute('readonly', "readonly");
                }else{
                    this.removeAttribute('readonly');
                }
            }

            static get observedAttributes() {
                return ['readonly'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'readonly':
                    this.applyReadonly();
                    break;
                }
            }

            applyReadonly(){
                const readonly = this.readonly ;

                let form = this.querySelector("form") ;
                if(!form){
                    if(this.children[0] && this.children[0].tagName === "TEMPLATE"){
                        const template = this.children[0] ;
                        if(template.content.children[0] && template.content.children[0].tagName === "FORM" ){
                            form = template.content.children[0] ;
                        }
                    }
                }
                if(form){
                    setReadonly(form, readonly) ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, FormComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}

function setReadonly(form, readonly){
    const readonlyElements = ["z-field", "z-field-only", "input", "textarea", "select", '[is="z-repeat-input"]', "z-search", "z-suggest"] ;

    const innerForms = form.querySelectorAll("z-form") ;
    const excludedFields = [] ;
    const excludedTemplates = [] ;
    const excludedGrids = [] ;
    for(let innerForm of innerForms){
        for(let elName of readonlyElements){
            const els = innerForm.querySelectorAll(elName) ;
            for(let el of els){
                excludedFields.push(el) ;
            }
        }
        let els = innerForm.querySelectorAll("template") ;
        for(let el of els){
            excludedTemplates.push(el) ;
        }
        els = innerForm.querySelectorAll("z-grid") ;
        for(let el of els){
            excludedGrids.push(el) ;
        }
    }
    for(let elName of readonlyElements){
        const els = form.querySelectorAll(elName) ;
        for(let i = 0; i<els.length; i++){
            const el = els[i] ;
            if(excludedFields.includes(el)){
                continue ;
            }
            if(el.tagName === "Z-FIELD" || el.tagName === "Z-FIELD-ONLY"){
                for(let elSubName of readonlyElements){
                    const subEls = el.querySelectorAll(elSubName) ;
                    for(let y = 0; y<subEls.length; y++){
                        excludedFields.push(subEls[y]) ;
                    }
                }
                const subGridEls = el.querySelectorAll("z-grid") ;
                for(let y = 0; y<subGridEls.length; y++){
                    excludedGrids.push(subGridEls[y]) ;
                }
            }
            
            if(el.hasAttribute("z-never-readonly")){
                continue;
            }
            if(el.hasAttribute("readonly") && el.getAttribute("readonly")[0]==="$"){
                //this field has a special rule for readonly, let it be
                continue;
            }
            if(el.hasAttribute("z-bind")){
                try{
                    if(JSON.parse(el.hasAttribute("z-bind")).readonly){
                        //this field has a special rule for readonly, let it be
                        continue ;
                    }
                }catch(e){
                    //ignore
                }
            }
            if(readonly){
                if(elName === "input" && (el.type === "radio" || el.type === "checkbox")){
                    el.setAttribute("disabled", "disabled") ;
                }else{
                    el.setAttribute("readonly", "readonly") ;
                }
            }else{
                if(elName === "input" && (el.type === "radio" || el.type === "checkbox")){
                    el.removeAttribute("disabled") ;
                }else{
                    el.removeAttribute("readonly") ;
                }
            }
        }
    }

    const gridElement = form.querySelectorAll("z-grid") ;
    for(let gridEl of gridElement){
        if(excludedGrids.includes(gridEl)){
            continue ;
        }
        if(gridEl.hasAttribute("z-never-readonly")){
            continue;
        }
        let listEl = gridEl.closest("z-list") ;
        if(listEl && listEl.hasAttribute("z-never-readonly")){
            continue;
        }
        if(gridEl.setEditable){
            gridEl.setEditable(!readonly, false) ;
        }
    }

    const templates = form.querySelectorAll("template") ;
    for(let i=0; i<templates.length; i++){
        if(excludedTemplates.includes(templates[i])){
            continue ;
        }
        setReadonly(templates[i].content, readonly) ;
    }
}